export default function canViewActivity(activity) {
	if (activity.module && activity.module_row_id) {
		if (activity.interaction.startsWith('Deleted')) {
			return false;
		}

		return true;
	}

	return false;
}
